import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  title: 'Edit Settings for Invoices',
  description:
    'Changes to Settings will only impact Draft and future Invoices, and cannot be applied to Invoices which have already been sent.',
})
